export const apiConfig = {
    auth: {
        login: 'Master/login',
        logout: '/Master/logout',
        googleSignIn: '/Master/google-signin',
    },
    dashboardWidgets: {
        totalWidgets: 'dashboard_widgets/total_widgets_v2',
        totalWidgetsBarPlot: 'dashboard_widgets/total_widgets_bar_plot_v2',
        totalWidgetsCharts: 'dashboard_widgets/total_widgets_charts_v2',
        getDownloadDetails: '/utils/downloads',
        deleteDownloadRecord :'/Master/delete_download_record',
        recordDownloaded : 'utils/update_download_status'
    },
    utils: { languages: 'utils/languages',languageTranslation:"utils/translate_language" },
    shiftData: {
        getMasterSite: 'Master/site',
        getMasterStatus: '/Master/asset_status',
        getAssetTypesInAssets: 'Master/asset_types_in_assets',
        generateShiftDataExcelFile: '/Master/export_shift_data_excel_file',
        generateMasterExcelFile: '/Master/export_master_data_excel_file',
        getAllShiftData: '/Master/get_all_shift_data',
        getAllShiftDataV2: 'Master/get_all_shift_data_v2',
        getAllMasterData: 'Master/site_assets',
        getAllMasterDataV2: '/Master/site_assets_v2',
        getMasterDataSummary: 'Master/site_assets/summary',
        getShiftDataSummary: 'Master/shift_data/summary',
        generateShiftDataPdf: '/Master/export_shift_data_pdf_file',
        generateMasterDataPdf: '/Master/export_master_data_pdf_file',
        generateShiftDataShapefile: 'Master/export_shift_data_as_shape_file',
        generateWorkOrderExcelFile:'/Master/work_order_report',
        getLastSurveyDate :'utils/get_last_video_uploaded_date', // last surveyed on
        getIssueTypeData :'/utils/get_issues'

    },
    masterData: {
        generateMasterDataShapefile: '/Master/export_master_data_as_shape_file',
        getCategoryDetails: 'Master/get_all_category_details',
        addNewAnomaly:'Master/add_new_anomaly_wo',/**to add new anomaly */
        getmasterDetailsForPreview : 'Master/get_master_details',
        /**button to mark given master as 'Not our Asset' */
        //deleteSiteAssetFromMaster: '/Master/delete_site_asset',
    },
    workOrder: {
        getWorkOrderData: 'Master/get_work_order_data',
        updateWorkOrder: '/Master/update_wo_item',
        manulClose: '/Master/manual-close',
    },
    user: {
        userOrganisation: 'user/organisation',
        preferences: '/preferences',
        userPermissions: 'user/permissions',
        getAllUserDetails  : 'AdminPanel/get_all_users',
        getAllDepartmentsDetails  : 'AdminPanel/get_all_departments',
        addNewUser : 'AdminPanel/add_user'
    },
    trackingModule: {
        siteLatlongs: 'Tracking_Module/dashboard/site-latlongs',
        coveredLatLongs: 'Tracking_Module/dashboard/covered-latlongs',
        distanceStats: 'Tracking_Module/dashboard/distance_stats',
        uncoveredChainages: 'Tracking_Module/dashboard/uncovered_chainages',
        exportTrackingModuleExcelfile: '/Tracking_Module/export_tracking_module_excel_file',
    },
    department:{
        getAssetData: '/AdminPanel/get_assets',
        createDepartment : '/AdminPanel/add_department',
        getAssetDepartmentDetails : 'AdminPanel/get_department_names_of_assets',
        moveToOtherDepartment : '/AdminPanel/move_assets'
    },
    sla:{
        getSiteInformation : '/AdminPanel/get_site_information',
        getSLADaysDetails : '/AdminPanel/get_sla_days_of_assets',
        updateSiteInformation : '/AdminPanel/update_site_information',
        updateSLADays : '/AdminPanel/update_sla_days',
    },
    exclusion:{
        getExclusionDetails : '/AdminPanel/get_all_site_exclusions',
        addExclusionDetails : 'AdminPanel/add_site_exclusion',
        deleteExclusion : '/AdminPanel/delete_site_exclusion',
        updateExclusionDetails : '/AdminPanel/update_site_exclusion',
    },
    clearCache : {
        clearAllCache : '/utils/clear-all-cache'
    },
    reports : {
        getAllReportsData : 'Master/get_all_reports_data',
        get_weekly_reports : 'Master/get_weekly_reports',
        get_monthly_reports : 'Master/get_monthly_reports',
        get_estimated_time_reports : 'Master/get_estimated_time'
    }
};
